import { NEW_ENDPOINTS } from '@constants'
import { ISingleProduct } from '@typings'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { BaseApi } from './_base.api'

export class ProductApi extends BaseApi {
  getAll = (params?: AxiosRequestConfig['params']) =>
    this.api
      .get<AxiosResponse<ISingleProduct[]>>(NEW_ENDPOINTS.PRODUCT.LIST, { params })
      .then(res => res.data.data)

  create = async (data: Partial<ISingleProduct>) =>
    await this.api.post(NEW_ENDPOINTS.PRODUCT.LIST, data).then(res => res.data.data)

  update = (id: ISingleProduct['id'], data: Partial<ISingleProduct>) =>
    this.api.put(NEW_ENDPOINTS.PRODUCT.SINGLE(id), data).then(res => res.data.data)

  getSingle = (id: ISingleProduct['id'], params?: AxiosRequestConfig['params']) =>
    this.api
      .get<AxiosResponse<ISingleProduct>>(NEW_ENDPOINTS.PRODUCT.SINGLE(id), params)
      .then(res => res.data.data)

  delete = (id: ISingleProduct['id']) =>
    this.api.delete(NEW_ENDPOINTS.PRODUCT.SINGLE(id)).then(res => res.data)
}
